<template>
    <v-row>
      <v-btn  color="white" depressed class="text-decoration-underline text-primary mr-2" @click="selectAll">Select All </v-btn>
      <v-btn color="white" depressed class="text-decoration-underline text-primary" @click="selectNone">Unselect All</v-btn>
  </v-row>
</template>

<script>
export default {
  name: 'SelectBtn',
  methods: {
    selectAll () {
      this.$emit('selectall')
    },
    selectNone () {
      this.$emit('selectnone')
    }
  }
}
</script>

<style>

</style>
